function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import cn from 'classnames';
import { useAnimation } from '../../../hooks/useAnimation';
import { useIsomorphicLayoutEffect as useLayoutEffect } from '../../../hooks/useIsomorphicLayoutEffect';
import { getAutoHeightDuration } from '../../../_internal_/utils/getAutoHeightDuration';
require("./DrawerInline.css");
var styles = {
  "Root": "DrawerInline-module-Root_4ea",
  "Content": "DrawerInline-module-Content_3h6"
};
/**
 * Компонент выдвижная панель, "выталкивает" содержимое родительской страницы при открытии;
 * @interface IDrawerInlineProps
 * @author m.mayorov
 */
export const DrawerInline = ({
  children,
  className,
  innerRef,
  controlRef,
  isExpanded = false,
  size = '236px',
  collapsedSize = '0px',
  style,
  ...props
}) => {
  const measureValue = parseInt(size.replace(/\D/g, ''));
  const [{
    width
  }, start] = useAnimation({
    width: isExpanded ? size : collapsedSize
  });
  useLayoutEffect(() => {
    if (typeof window !== 'undefined') {
      window.requestAnimationFrame(() => start({
        width: isExpanded ? size : collapsedSize
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExpanded]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cn(styles.Root, className),
    ref: controlRef || innerRef,
    style: {
      ...style,
      width,
      transitionDuration: `${getAutoHeightDuration(measureValue || 0)}ms`
    },
    "aria-hidden": Number(width?.toString().replace(/\D/g, '')) === 0
  }, props), /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Content)
  }, children));
};
if (process.env.NODE_ENV !== 'production') {
  DrawerInline.displayName = 'DrawerInline';
}